import React from "react";
import IconBell from "../../../../assets/icons/bell-blue.png";
import { useChatContext } from "../../../../providers/Chat";
import { useGlobalContext } from "../../../../providers/global";
import {
  StyledAlertIcon,
  StyledIcon,
  StyledUserAvatar,
  StyledUserAvatarContainer,
  StyledUserInfoContainer,
  StyledUserName
} from "./Header.style";

const defaultAvatar = "https://www.w3schools.com/howto/img_avatar.png";

const UserInfo = () => {
  const { currentUser } = useGlobalContext();
  const { isConnected } = useChatContext();
  return (
    <StyledUserInfoContainer>
      <StyledUserAvatarContainer isOnline={isConnected}>
        <StyledUserAvatar
          src={currentUser.image || defaultAvatar}
          alt={currentUser.firstName}
        />
      </StyledUserAvatarContainer>
      <StyledUserName>{currentUser.firstName}</StyledUserName>
      <StyledAlertIcon>
        <StyledIcon src={IconBell} alt="alert icon" />
      </StyledAlertIcon>
    </StyledUserInfoContainer>
  );
};

export default UserInfo;
